import api from '@/api'

export default {
  state: {
    userInfo: {},
    token: ''
  },

  getters: {
    userInfo: (state) => state.userInfo,
    token: (state) => state.token

  },

  mutations: {
    SET_USER_INFO(state, data) {
      state.userInfo = data
      localStorage.setItem('userInfo', JSON.stringify(data))
      localStorage.setItem('userName', data.userName)
    },
    SET_TOKEN: (state, token) => {
      state.token = token
      localStorage.setItem('token', token)
    },
    LOG_OUT(state, data) {
      state.userInfo = {}
      state.token = ''
      localStorage.clear()
    }

  },

  actions: {
    // setUserInfo({ commit }, data) {
    //   commit('USER_INFO', data)
    // },
    // setToken({ commit }, data) {
    //   commit('SET_TOKEN', data)
    // },
    LOGOUT({ commit }, data) {
      commit('LOG_OUT', data)
    },
    LOGIN({ commit, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        api
          .login(userInfo)
          .then((res) => {
            commit('SET_USER_INFO', res.data.user)
            localStorage.setItem('className', res.data.className)
            commit('SET_TOKEN', res.data.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
